// extracted by mini-css-extract-plugin
export var container = "RefundableLabel-module--container--6f794";
export var icon = "RefundableLabel-module--icon--d3c54";
export var label = "RefundableLabel-module--label--107fe";